import React, {Component} from 'react';
import PropTypes from "prop-types";
import {loadCSS} from 'fg-loadcss/src/loadCSS';
import {Icon} from '@material-ui/core';
import classNames from 'classnames';
import {withStyles} from '@material-ui/core/styles';
import {red} from '@material-ui/core/colors';

class UecareIcon extends Component {

    static propTypes = {
        classes: PropTypes.object.isRequired,
    };

    componentDidMount() {
        loadCSS(
            'https://use.fontawesome.com/releases/v5.1.0/css/all.css',
            document.querySelector('#insertion-point-jss'),
        );
    }

    render() {
        const {classes} = this.props;

        return (
            <div className={classes.root}>
                <Icon className={classNames(classes.icon, 'fa fa-plus-circle')}/>
                <Icon className={classNames(classes.icon, 'fa fa-plus-circle')} color="primary"/>
                <Icon className={classNames(classes.icon, 'fa fa-plus-circle')} color="secondary"/>
                <Icon className={classNames(classes.icon, 'fa fa-plus-circle')} color="action"/>
                <Icon
                    className={classNames(classes.iconHover, 'fa fa-plus-circle')}
                    color="error"
                    style={{fontSize: 30}}
                />
                <Icon
                    className={classNames(classes.icon, 'fa fa-plus-circle')}
                    color="disabled"
                    fontSize="large"
                />
            </div>
        );
    }
}

const styles = theme => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-end',
    },
    icon: {
        margin: theme.spacing.unit * 2,
    },
    iconHover: {
        margin: theme.spacing.unit * 2,
        '&:hover': {
            color: red[800],
        },
    },
});

export default withStyles(styles)(UecareIcon);



// WEBPACK FOOTER //
// ./src/components/UecareIcon.js